import {SectionFragmentDto} from "@hec/api-dtos";
import {DormerRootState, getSelectableSectionFragmentsSelector} from "../../";

export const getSelectableSectionFragmentById = (state: DormerRootState, id: string): SectionFragmentDto | undefined => {
  const sectionFragments: SectionFragmentDto[] = getSelectableSectionFragmentsSelector(state) as SectionFragmentDto[];

  return sectionFragments.find(sf => sf.id === id);
}
